import { api } from '../core';

export interface BundleMarkBreachRequest {
  bundleId: string;
  pageIds: string[];
}

/**
 * Permanently redacts the given pages. The backend swaps each page's PDF and
 * thumbnail in the blob store under the same page id, so bundle sections are
 * unchanged. Callers refetch /bundle afterwards for fresh page URLs.
 */
const bundleMarkBreachApi = api.injectEndpoints({
  endpoints: (builder) => ({
    bundleMarkBreach: builder.mutation<unknown, BundleMarkBreachRequest>({
      query: ({ bundleId, pageIds }: BundleMarkBreachRequest) => ({
        url: 'bundle/mark/breach',
        method: 'POST',
        body: { bundleId, pageIds },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useBundleMarkBreachMutation } = bundleMarkBreachApi;
